import { render, staticRenderFns } from "./CuerpoTecnicoView.vue?vue&type=template&id=52ba3289&"
import script from "./CuerpoTecnicoView.vue?vue&type=script&lang=js&"
export * from "./CuerpoTecnicoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports